<template>
  <v-card outlined height="600" class="d-flex flex-column preview-container">
    <v-card-title class="text-subtitle-1 d-flex align-center">
      {{ $t('Preview') }}
      <v-fade-transition>
        <v-btn
          v-if="needsRefresh"
          color="primary"
          small
          class="ml-auto"
          @click="$emit('refresh')"
        >
          <v-icon left small>mdi-content-save-outline</v-icon>
          {{ $t('Save & Preview') }}
        </v-btn>
      </v-fade-transition>
    </v-card-title>
    <v-card-text class="flex-grow-1 pa-0 preview-frame-container">
      <v-form ref="form">
        <v-fade-transition>
          <v-skeleton-loader v-if="isLoading" type="image" height="100%" />
        </v-fade-transition>
        <iframe
          ref="previewFrame"
          :src="currentUrl"
          width="100%"
          height="100%"
          frameborder="0"
          :style="{ display: isLoading ? 'none' : 'block' }"
          @load="onFrameLoad"
        />
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PreviewFrame',

  props: {
    url: {
      type: String,
      required: true,
    },
    needsRefresh: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: true,
      currentUrl: this.url,
    }
  },

  watch: {
    url: {
      handler(newUrl) {
        this.refreshFrame(newUrl)
      },
    },
  },

  methods: {
    onFrameLoad() {
      this.isLoading = false
      this.$emit('load')
    },

    refreshFrame(newUrl = this.url) {
      this.isLoading = true
      this.currentUrl = 'about:blank'

      // Use setTimeout to ensure the blank page loads first
      setTimeout(() => {
        this.currentUrl = newUrl
      }, 100)
    },
  },
}
</script>

<style scoped>
.preview-container {
  position: relative;
}

.preview-frame-container {
  position: relative;
}

iframe {
  border: none;
}
</style>
